// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class BtnBadgeCount extends WebComponent {
	didMount() {
    const selectedItems = document.querySelectorAll('.selected-filters__list .selected-filters__item');
    const target = this.element.querySelector('.badge');

    if ((selectedItems) && (selectedItems.length != 0)) {
      target.innerHTML = selectedItems.length;
    }
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/BtnBadgeCount.js